'use strict';

export function routeConfig(GLOBALS, $routeProvider, $locationProvider, $mdThemingProvider, $httpProvider, $sceDelegateProvider) {
  'ngInject';

  $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets domain. **.
    'https://youtube.com/**',
    'https://www.youtube.com/**',
    'https://vimeo.com/**',
    'https://youtu.be/**'
  ]);

  $routeProvider.otherwise({
    redirectTo: '/'
  });

  var mppBlueGreyMap = $mdThemingProvider.extendPalette('yellow', {
    500: '#f9d70b'
  });

  // Register the new color palette map with the name <code>neonRed</code>
  $mdThemingProvider.definePalette('mppBlueGrey', mppBlueGreyMap);

  $mdThemingProvider.theme('default')
    .primaryPalette('mppBlueGrey')
    .accentPalette('light-blue')
    .warnPalette('red');

  $locationProvider.html5Mode(!GLOBALS.appBuild);
  $httpProvider.interceptors.push('REST_Interceptor');
}



// WEBPACK FOOTER //
// ./client/app/app.config.js